// sanityClient.js
import { createClient } from "@sanity/client";
import imageUrlBuilder from "@sanity/image-url";

export const sanityClient = createClient({
  projectId: "cfwmwjkv", // find in sanity.json or sanity.config.ts
  dataset: "production",
  apiVersion: "2023-08-01", // use current date
  useCdn: true,
});

const builder = imageUrlBuilder(sanityClient);
export const urlFor = (source) => builder.image(source);
